import { blue, FaroStatusText, green, neutral, purple } from "@flat-ui";
import { AnnotationStatus } from "@faro-lotv/ielement-types";

/** Different colors of the status */
export interface MarkupStatusColorReturn {
  /** The color of the icon */
  icon: string;

  /** The color of the icon's background color */
  iconBackground: string;

  /** The color of the icon's border color */
  iconBorder: string;
}

/** Contains different colors for (icon, icon-background, icon-border) based on the status */
export const markupStatusColor: Record<
  AnnotationStatus,
  MarkupStatusColorReturn
> = {
  [AnnotationStatus.Open]: {
    icon: neutral[700],
    iconBackground: neutral[100],
    iconBorder: neutral[300],
  },
  [AnnotationStatus.InProgress]: {
    icon: blue[500],
    iconBackground: blue[50],
    iconBorder: blue[100],
  },
  [AnnotationStatus.ToReview]: {
    icon: purple[500],
    iconBackground: purple[50],
    iconBorder: purple[100],
  },
  [AnnotationStatus.Resolved]: {
    icon: green[700],
    iconBackground: green[50],
    iconBorder: green[100],
  },
  [AnnotationStatus.Unclassified]: {
    icon: neutral[500],
    iconBackground: neutral[0],
    iconBorder: neutral[300],
  },
};

/** All the dropdown options for markup status */
export interface MarkupStatusOption {
  /** Unique key for every option */
  key: AnnotationStatus;

  /** Value represents each key */
  value: AnnotationStatus;

  /** Text to show for each option */
  label: string;
}

/** List of available options to use for the DropDownMarkupField's value property */
export const STATUS_OPTIONS: MarkupStatusOption[] = Object.values(
  AnnotationStatus
).map((status) => ({
  key: status,
  value: status,
  label: FaroStatusText[status],
}));
